/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable eqeqeq */
import React from 'react';

// Renders one button per ENABLED late-upload action, read from the backend config
// (epod_late_upload.approval_actions) via epodScreen's state - never a hardcoded
// "if (status === 'late') showApprove()". With today's config that means Approve only; enabling
// Reject later is a config change and this component starts rendering it with no code edit.
//
// The backend re-validates the action, the state and the upload_seq on every call, so hiding a
// button here is convenience for the operator, not a security control.
//
// Reject does NOT call the backend directly - clicking it only opens epodScreen's mandatory
// rejection-remarks modal (onClickEpodGateReject). The modal's "Confirm Reject" is what actually
// submits the API call, per the requirement that rejection is never a single click.
const EpodGateActions = (props) => {
    const parentState = (props.context && props.context.componentParent && props.context.componentParent.state) || {};
    const actions = parentState.epodGateActions || {};

    const enabled = Object.keys(actions).filter((k) => actions[k] === true);
    if (enabled.length === 0) return null;

    // Approve is a single-click straight to the API (no modal) - disable it while a request for
    // THIS row is in flight, so a rapid double-click can't fire two API calls. Reject already has
    // its own guard (the mandatory-remarks modal's epodRejectSubmitting).
    const busy = parentState.epodGateActionBusyRowId === props.data._id;

    const styleFor = () => ({ padding: '2px 10px', fontSize: '13px', margin: '0 4px 0 0' });
    const classFor = (action) => (action === 'approve' ? 'btn btn-success' : 'btn btn-danger');
    const labelFor = (action) => action.charAt(0).toUpperCase() + action.slice(1);

    const handleClick = (action) => (e) => {
        e.stopPropagation();
        if (action === 'reject') {
            props.context.componentParent.onClickEpodGateReject(props.data);
        } else {
            props.context.componentParent.onClickEpodGateAction(action, props.data);
        }
    };

    return (
        <div>
            {enabled.map((action) => (
                <button
                    key={action}
                    className={classFor(action)}
                    style={styleFor()}
                    title={labelFor(action) + ' late e-POD upload'}
                    onClick={handleClick(action)}
                    disabled={action === 'approve' ? busy : false}
                >
                    {action === 'approve' && busy ? 'Submitting...' : labelFor(action)}
                </button>
            ))}
        </div>
    );
};

export default EpodGateActions;
